"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LocalPhone_1 = __importDefault(require("@material-ui/icons/LocalPhone"));
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const config_1 = require("config");
const consumer_applications_v1_api_1 = require("consumer-applications-v1-api");
const context_1 = require("context");
const warn_svg_1 = __importDefault(require("images/utility-icons/warn.svg"));
const actions_1 = require("../../actions");
function PendHandler({ iframeUrl, personalInfo, prequalification, }) {
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const [isStillPending, setIsStillPending] = (0, react_1.useState)(false);
    const [ssnLastFour, setSsnLastFour] = (0, react_1.useState)('');
    const [getCreditApplicationsByStatus] = (0, consumer_applications_v1_api_1.useLazyGetConsumerApplicationsV1CreditApplicationsStatusStatusQuery)();
    const history = (0, react_router_dom_1.useHistory)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    (0, react_1.useEffect)(() => {
        if (personalInfo.ssn) {
            setSsnLastFour(personalInfo.ssn.slice(-4));
        }
        else if (personalInfo.ssnLast4) {
            setSsnLastFour(personalInfo.ssnLast4);
        }
    }, []);
    const submit = () => {
        setSubmitting(true);
        pendHandlingComplete();
    };
    const pendHandlingComplete = () => {
        setIsStillPending(false);
        getCreditApplicationsByStatus({
            status: 'pending',
            ssnLastFour: ssnLastFour,
            dateOfBirth: personalInfo.dateOfBirth,
            zip: personalInfo.zip,
            locationId: prequalification.location.locationId,
        }).then((res) => {
            const { data } = res;
            if (data && data.creditApplication?.applicationStatus === 'approved') {
                analytics?.track('ApplicationApproved', {});
                dispatch((0, actions_1.setApprovedApplication)(data.creditApplication));
                history.push({
                    pathname: config_1.WIZARD_URL,
                    state: {
                        step: 'APPROVAL',
                    },
                });
            }
            else if (data &&
                data.creditApplication?.applicationStatus === 'declined') {
                history.push(config_1.PRE_QUALIFICATION_ACCEPT_DECLINED_URL);
            }
            else {
                setIsStillPending(true);
                setSubmitting(false);
            }
        });
    };
    const openWindow = () => {
        if (isStillPending) {
            submit();
        }
        else {
            popupCenter(iframeUrl, 'Alphaeon Verification', 600, 800);
        }
    };
    const popupCenter = (url, title, w, h) => {
        // Fixes dual-screen position                             Most browsers      Firefox
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
        const width = window.innerWidth
            ? window.innerWidth
            : document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : screen.width;
        const height = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : screen.height;
        const systemZoom = width / window.screen.availWidth;
        const left = (width - w) / 2 / systemZoom + dualScreenLeft;
        const top = (height - h) / 2 / systemZoom + dualScreenTop;
        const newWindow = window.open(url, title, `
      scrollbars=yes,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `);
        newWindow?.focus;
        const interval = setInterval(() => {
            if (newWindow?.closed) {
                clearInterval(interval);
                submit();
            }
        }, 500);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "declined-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "content text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "step-up-pend-img", children: (0, jsx_runtime_1.jsx)("img", { src: warn_svg_1.default, alt: "red fail icon" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "pad-y-20", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "Almost Done!" }), isStillPending ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.P, { variant: "title-large", children: "Your application is still pending. It may take a few minutes for us to receive notification that the verification steps are complete. Please occassionally refresh the status to see if there are any updates. If there are no updates after 5 minutes, please call us." }), (0, jsx_runtime_1.jsx)("div", { className: "number-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-center text-center mar-b-20", children: [(0, jsx_runtime_1.jsx)(LocalPhone_1.default, {}), " \u00A0\u00A0\u00A0", (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: `tel:${config_1.AFF_NUMBER}`, children: config_1.AFF_NUMBER }) })] }) })] })) : ((0, jsx_runtime_1.jsx)(components_1.P, { variant: "title-large", children: "We need to verify some info before your application is complete." })), (0, jsx_runtime_1.jsxs)("div", { children: [prequalification?.lenderRequestReferenceId && ((0, jsx_runtime_1.jsxs)(components_1.P, { variant: "title-large", children: [' ', "Application ID: ", prequalification?.lenderRequestReferenceId] })), (0, jsx_runtime_1.jsx)(lp_components_1.SubmitButton, { type: "button", className: "button-warn qualify mar-t-0", onClick: () => openWindow(), submitting: submitting, children: isStillPending ? 'Refresh Status' : 'Start Verification' })] })] })] }) }) }));
}
exports.default = PendHandler;
